import { VacancyFilter } from "@/models"

export default {
  namespaced: true,

  state: {
    vacancyFilter: new VacancyFilter(),
  },

  getters: {
    vacancyFilter: state => state.vacancyFilter,
  },

  mutations: {
    setVacancyFilter(state, payload) {
      state.vacancyFilter = payload
    },
  }
}
